import { ChosenAppletData } from 'modules/Dashboard/features';
import { DateRangePickerFormValues } from 'shared/components/DateRangePicker';
import { SingleApplet } from 'shared/state';
import { UniqueTuple } from 'shared/types';
import { ExportDataFilters } from 'shared/utils';

export const enum ExportDataExported {
  ResponsesOnly = 'responsesOnly',
  ResponsesAndEhrData = 'responsesAndEhrData',
}

// The list of supplementary files that can be exported. These show up as checkboxes in the modal
// If the appearance of one or more of these checkboxes is controlled by a feature flag, add it
// to that flag's corresponding array, otherwise add it to the `none` array
export const SupplementaryFilesWithFeatureFlag = {
  enableEmaExtraFiles: ['flowHistory', 'scheduleHistory'],
  none: ['userJourney'],
} as const;

export const SupplementaryFiles = [
  ...SupplementaryFilesWithFeatureFlag.enableEmaExtraFiles,
  ...SupplementaryFilesWithFeatureFlag.none,
] as const;

export type SupplementaryFiles = (typeof SupplementaryFiles)[number];

export type SupplementaryFilesFormValues = {
  [key in SupplementaryFiles]: boolean;
};

export type ExportDataFormValues = DateRangePickerFormValues & {
  dataExported: ExportDataExported;
  supplementaryFiles: SupplementaryFilesFormValues;
};

export type ExportDataSettingProps = {
  isExportSettingsOpen: boolean;
  onExportSettingsClose: () => void;
  onDataExportPopupClose?: () => void;
  chosenAppletData?: ChosenAppletData | SingleApplet | null;
  isAppletSetting?: boolean;
  filters?: ExportDataFilters;
  supportedSupplementaryFiles?: UniqueTuple<SupplementaryFiles> | [];
  'data-testid'?: string;
};
